import styled from "styled-components";
import { NumberAvatar } from "@assets";
export const RootContainer = styled.div`
  position: relative;
  margin: 0 ;

  /* .ant-table-wrapper {
    margin: 82px 16px 24px 16px;
  } */
`;

export const ContentContainer = styled.div`
  padding: 0 ;
`
export const Top = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  margin: 24px 0 0 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const LightText = styled.p`
  color: #808080;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Text = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #C21C05;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

`;

export const FirendListContainer = styled.div`
  margin: 24px 0 0 0;
  border-top: 1px solid #EFEFEF;
`

export const FriendWrapper = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-bottom: 1px solid #EFEFEF;
  gap: 8px;
`

export const NumberContainer = styled.div`
  width: 60px;
  height: 60px;
  position: relative;
`
export const NumberBackgroundAvatar = styled(NumberAvatar)`
`
export const Number = styled.p`
  color: #C21C05;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  position: absolute;
  top: 23px;
  left: 24px;
`

export const TextContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
`
export const NameAndDateContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`
export const Name = styled.p`
  flex-grow: 1;
  color: #C21C05;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`
export const Date = styled.p`
  color:  #283234;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const PhoneNumber = styled.div`
  width: 100%;
  color: #808080;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const SpinWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`;
